import { IconType } from '@/types';

export default function WhatsAppIcon({ className, width = 20, height = 20 }: IconType) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M2.5 17.5L3.875 14.3333C1.69848 11.2437 2.16086 7.01725 4.95392 4.47128C7.74698 1.9253 11.9981 1.85525 14.8735 4.30782C17.7489 6.76039 18.3503 10.9693 16.2768 14.129C14.2032 17.2887 10.1026 18.4119 6.70833 16.75L2.5 17.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.5 8.33334C7.5 8.56346 7.68655 8.75001 7.91667 8.75001C8.14679 8.75001 8.33333 8.56346 8.33333 8.33334V7.50001C8.33333 7.26989 8.14679 7.08334 7.91667 7.08334C7.68655 7.08334 7.5 7.26989 7.5 7.50001V8.33334C7.5 10.6345 9.36548 12.5 11.6667 12.5H12.5C12.7301 12.5 12.9167 12.3135 12.9167 12.0833C12.9167 11.8532 12.7301 11.6667 12.5 11.6667H11.6667C11.4365 11.6667 11.25 11.8532 11.25 12.0833C11.25 12.3135 11.4365 12.5 11.6667 12.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
